import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../config/siteConfig";
import "../css/privacy.scss";

function Privacy() {
  return (
    <main id="main-content" className="privacy-page">
      <header className="privacy-page__header" aria-labelledby="privacy-title">
        <p className="privacy-page__eyebrow">Information</p>
        <h1 id="privacy-title">Privacy policy</h1>
        <p>
          This policy explains how {siteConfig.legalName} collects, uses and
          protects personal information when you visit or shop with us.
        </p>
        <p className="privacy-page__updated">
          Last updated <time dateTime="2026-08-17">17 August 2026</time>
        </p>
      </header>

      <div className="privacy-page__body">
        <section aria-labelledby="privacy-collect">
          <h2 id="privacy-collect">1. Information we collect</h2>
          <p>
            When you place an order or contact us, we may receive your name,
            billing and delivery address, email address, order
            details and correspondence. Payment details are processed by our
            secure payment provider and are not stored by us in full.
          </p>
          <p>
            We may also receive limited technical information, such as browser
            type, device information and pages visited, to keep the website
            secure and understand how it is used.
          </p>
        </section>

        <section aria-labelledby="privacy-use">
          <h2 id="privacy-use">2. How we use it</h2>
          <p>We use personal information only where there is a lawful reason to do so:</p>
          <ul>
            <li>to process, deliver and support your order;</li>
            <li>to answer enquiries and provide customer support;</li>
            <li>to prevent fraud and maintain the security of the website;</li>
            <li>to meet legal, tax and accounting obligations.</li>
          </ul>
        </section>

        <section aria-labelledby="privacy-sharing">
          <h2 id="privacy-sharing">3. Sharing and retention</h2>
          <p>
            We share only the information needed by trusted providers that help
            us take payments, host the website, deliver parcels and operate the
            business. We do not sell personal information. We keep records only
            for as long as necessary for the purposes above or as required by law.
          </p>
        </section>

        <section aria-labelledby="privacy-cookies">
          <h2 id="privacy-cookies">4. Cookies and local storage</h2>
          <p>
            Essential cookies and browser storage may be used to remember your
            basket, keep checkout secure and retain basic site preferences.
            Optional analytics or marketing technologies should be used only
            with the consent required by applicable law.
          </p>
        </section>

        <section aria-labelledby="privacy-rights">
          <h2 id="privacy-rights">5. Your rights</h2>
          <p>
            Depending on where you live, you may ask to access, correct, erase
            or restrict use of your personal information, object to certain uses
            or request a portable copy. You may also withdraw consent at any time.
          </p>
          <p>
            To make a request, email{" "}
            <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.
            We may need to confirm your identity before responding.
          </p>
        </section>

        <section aria-labelledby="privacy-contact">
          <h2 id="privacy-contact">6. Contact</h2>
          <address>
            {siteConfig.legalName}
            <br />
            {siteConfig.contact.address.map((line) => (
              <React.Fragment key={line}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </address>
          <p>
            For related site rules, please read our <Link to="/terms">terms of service</Link>.
          </p>
        </section>
      </div>
    </main>
  );
}

export default Privacy;
